<template>
  <HomeMobile v-if="isMobile" />
  <HomePc v-else />
</template>

<script>
import { mapState } from 'vuex'
import HomePc from './home.pc/Index.vue'
import HomeMobile from './home.mobile/Index.vue'

export default {
  name: 'coupon',
  components: {
    HomePc,
    HomeMobile
  },
  data () {
    return {
    }
  },
  computed: {
    ...mapState([
      'isMobile'
    ])
  },
  created () {

  },
  destroyed () {
  },
  methods: {

  }
}
</script>
